const MAX_AUTOCOMPLETE_SUGGESTIONS = 10;

const MAX_CHARACTER_COUNT_TITLE = 30;

export { MAX_CHARACTER_COUNT_TITLE, MAX_AUTOCOMPLETE_SUGGESTIONS };
